module.exports = __webpack_public_path__ + "fonts/outline-icons.cd6c777f.cd6c777f.woff2";